export default __webpack_public_path__ + "static/media/welcome-bg6.88f47302.png";